import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import {
  FETCH_EXERCISES_FAIL,
  DeleteExerciseActionType,
  DELETE_EXERCISE_SUCCESS,
  DELETE_EXERCISE
} from '../redux/exercisesReducer'

function* DeleteExerciseFlow(action: DeleteExerciseActionType): Generator<any, void, any> {
  try {
    yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/${action.payload.lessonPlanId}/exercises/${action.payload.exerciseId}`,
      method: 'DELETE',
      params: {}
    })
    yield put(
      DELETE_EXERCISE_SUCCESS({ lessonPlanId: action.payload.lessonPlanId, exerciseId: action.payload.exerciseId })
    )
  } catch (error) {
    yield put(FETCH_EXERCISES_FAIL())
    console.log(error)
  }
}

export default function* DeleteExerciseSaga(): Generator<any, void, any> {
  yield takeLatest([DELETE_EXERCISE], DeleteExerciseFlow)
}
